<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'billing.holidayGroups.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="creation-form">
      <button *ngIf="!isCreationMode" (click)="onEdit()" [matTooltip]="'billing.holidayGroups.add' | translate"
        mat-mini-fab class="action-button" color="primary">
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
      <app-holiday-group-edit *ngIf="isCreationMode && !editedId"
        (editFinished)="onEditFinished()"></app-holiday-group-edit>
    </section>

    <mat-form-field class="filterField">
      <mat-label>Filtrer</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Votre filtre" #input>
    </mat-form-field>

    <section class="datatable-holidayGroups">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom </th>
          <td mat-cell *matCellDef="let holidayGroup"> {{ holidayGroup.name }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{ 'billing.holidayGroups.list.actions' | translate }} </th>
          <td mat-cell *matCellDef="let holidayGroup">
            <ng-container *ngIf="holidayGroup.id !== editedId">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'billing.holidays.list.edit' | translate" (click)="onEdit(holidayGroup.id)">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>
            </ng-container>
            <ng-container>
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'billing.holidays.list.delete' | translate" (click)="delete(holidayGroup.id)">
                <mat-icon aria-label="Delete">delete</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let holidayGroup" [attr.colspan]="displayedColumns.length">
            <div *ngIf="holidayGroup.id === editedId" class="row-edit"
              [@detailExpand]="holidayGroup.id === editedId ? 'expanded' : 'collapsed'">
              <app-holiday-group-edit [holidayGroup]="holidayGroup"
                (editFinished)="onEditFinished()"></app-holiday-group-edit>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
          [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons [length]="holidayGroups.length"
        class="paginator"></mat-paginator>
    </section>
    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
  </mat-card-content>
</mat-card>